import { createRootRouteWithContext, HeadContent, Outlet } from '@tanstack/react-router'

import { Impersonator } from '@/components/shell'
import { isDevToolsEnabled } from '@/lib/dev/devTools'
import type { RouterContext } from '@/router'

export const Route = createRootRouteWithContext<RouterContext>()({
  head: () => ({
    meta: [{ title: 'Aplikace Bitez' }],
  }),
  component: RootLayout,
})

/**
 * The app frame. Mobile-native by design: on a phone the screen IS the app, on
 * desktop it is centred in a phone frame (`PhoneShell`) — a desktop layout is
 * explicitly a later decision.
 *
 * The `Impersonator` (spec §1 "Dev" role) floats bottom-right and switches
 * roles by navigating, since roles are URL segments. It only renders when the
 * dev tools are on — always under `bun dev`, opt-in via `?dev=1` in a build
 * (`lib/dev/devTools.ts`), so a URL shared with a client shows a clean app.
 */
function RootLayout() {
  return (
    <div className="app-no-scrollbars min-h-dvh bg-surface lg:flex lg:items-center lg:justify-center">
      <HeadContent />
      <Outlet />
      {isDevToolsEnabled() && <Impersonator />}
    </div>
  )
}
